import request from '@/utils/request'


export function GetAllOrderSchools(branchId) {
    return request({
        url: '/OrderSchool/GetAllOrderSchools',
        method: 'post',
        data: {
            BranchId: branchId
        }

    })
}

export function SaveSchool(id, branchId, schoolId, mablaqBedehkariMojaz, kpriceStudent, kpriceTeacher, kpricePersonel, isActive) {
    return request({
        url: '/OrderSchool/Save',
        method: 'post',
        data: {
            Id: id,
            BranchId: parseInt(branchId),
            SchoolId: schoolId,
            MablaqBedehkariMojaz: mablaqBedehkariMojaz,
            IsActive: isActive,
            KpriceStudent: kpriceStudent,
            KpriceTeacher: kpriceTeacher,
            KpricePersonel: kpricePersonel
        }

    })
}

export function DeleteSchool(id) {
    return request({
        url: '/OrderSchool/Delete',
        method: 'post',
        data: {
            Id: id,

        }

    })
}